/**
  Season ticket holder waiting list component
 */
import React, {  useEffect, useState } from 'react';
import { HolderModel } from '../models/holder.model';
import { FullLoader } from './loader.component';
import styles from './waiting-list-summary.module.scss';
import { useOktaAuth } from '@okta/okta-react';
import { useLocation } from 'react-router-dom';
import { CmsConfigs } from '../models/configs.model';
import { getConfigs, getHomepath } from '../util/cms-utils';
import { HolderService, HOLDER_STATUS_VERIFY_EMAIL, HOLDER_STATUS_NOT_ENTITLED } from '../services/holder.service';

interface OwnProps {
  holderHost: string;
}

const WaitingListSummary = ({ holderHost }: OwnProps) => {
  const { authState } = useOktaAuth()
  const holderService: HolderService = new HolderService(authState, holderHost);
  const initialHolder: HolderModel = {
    firstName: '',
    lastName: '',
    company: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
    country: '',
    phoneNumberPrimary: '',
    phoneNumberSecondary: '',
    dateOfBirth: ['', '', ''],
    learnMore: [],
    email: '',
    clubCode: '',
    venueId: '',
    waitingListNumber: '',
    cubsSms: false,
    cubsAlertsSms: false,
  };

  const [holder, setHolder] = useState<HolderModel>(initialHolder);
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [config, setConfig] = useState<CmsConfigs>();
  const query = new URLSearchParams(useLocation().search);

  useEffect(() => {
    const config: CmsConfigs = getConfigs(query.get("clubCode"));
    init(config);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ /* on did mount */]);

  const init: (config: CmsConfigs) => void = async (config: CmsConfigs): Promise<void> => {

    try {
      setShowLoading(true);
      setConfig(config);
      if (!config.features.includes("waitingList")) {
        // Club don't have waiting list function
        window.parent.location.href = `${getHomepath(config)}/message/not-entitled`;
      }
      const result: HolderModel = await holderService.getValidationStatus(config.clubCode, config.venueId);
      if (result && result.email) {
        setHolder(result);
      } else {
        // user need to signup
        window.parent.location.href = `${getHomepath(config)}/sign-up`;
      }
    } catch (_error) {
      const error = _error as Error
      if (error.message === HOLDER_STATUS_VERIFY_EMAIL) {
        // app will show email verify button
        window.parent.location.href = `${getHomepath(config)}/app`;
      } else if (error.message === HOLDER_STATUS_NOT_ENTITLED) {
        window.parent.location.href = `${getHomepath(config)}/sign-up`;
      }
    } finally {
      setShowLoading(false);
    }
  };

  function handleParentRedirectSTHUpdate() {
    window.parent.location.href = `${getHomepath(config)}/sign-up`;
  }

  return (
    <div className={styles.box}>
      {showLoading && (
        <FullLoader />
      )}
      <h2 className={styles.heading}>My Waiting List Account</h2>
      <div className={styles.pad10}>
        <table className={styles.accountInfo}>
          <tbody>
            <tr>
              <td>Welcome: <span id="user_bill_fname">{holder.firstName}</span> <span id="user_bill_lname">{holder.lastName}</span></td>
            </tr>
            <tr>
              <td>Account Number: <span id="user_account_num">{holder.accountId}</span></td>
            </tr>
            <tr>
              <td>Your Current Place on the Waiting List: <b><span id="user_waiting_list_number">{holder.waitingListNumber}</span></b></td>

            </tr>
            <tr>
              <td>Contact Email Address: <span id="user_email_addr">{holder.email}</span></td>
            </tr>
          </tbody>
        </table>

        <img src="https://secure.mlb.com/chc/images/ticketing/y2015/divider_large.png" alt='' className={styles.center} width="95%" />
        <br /><br />
        <p style={{ textAlign: "center" }} >
          <button className={styles.bamButtonPrimary} onClick={handleParentRedirectSTHUpdate} type='button'>Update your information</button>
        </p>
        <p style={{ font: "12px arial,helvetica,sans-serif" }}>You can update your e-mail address by emailing <strong>cubswaitinglist@cubs.com</strong> or calling <strong>773-404-CUBS</strong>. <b><u>Please do not update your email address via your Cubs.com/MLB.com profile after registering as this will not properly update your information.</u></b></p>
      </div>
    </div>
  );
};

export default WaitingListSummary;
